import { useState } from "react";

const useLoginModel = () => {
  const [loginModel, setLoginModel] = useState({
    isOpenForWeb: false,
    isOpenForMobile: false
  });

  const isOpen = loginModel.isOpenForMobile || loginModel.isOpenForWeb;
  const isMouseEventEnabled = loginModel.isOpenForWeb;

  const SetLoginModel = (action) => {
    switch (action) {
      case "SET_WEB_MODEL":
        setLoginModel((pre) => ({
          ...pre,
          isOpenForWeb: !pre.isOpenForWeb
        }))
        return;
      case "SET_MOBILE_MODEL":
        setLoginModel((pre) => ({
          ...pre,
          isOpenForMobile: !pre.isOpenForMobile
        }))
        return;
      case "CLOSE_ALL":
        setLoginModel((pre) => ({
          ...pre,
          isOpenForMobile: false,
          isOpenForWeb: false
        }));
        return;
      default:
        break;
    }
  }

  return {
    isOpen,
    isMouseEventEnabled,
    SetLoginModel
  }
};


export default useLoginModel;